export default "__VITE_ASSET__04f882a2__"